module.exports = __webpack_public_path__ + "img/eshoy_home_top02.f893966b.png";